export const TRANSLATIONS = {
  en: {
    // Top Chrome & Shell
    "nav.dashboard": "Dashboard",
    "nav.setup": "Setup",
    "nav.code": "Code",
    "nav.nursery": "Nursery",
    "nav.alpha": "Alpha",
    "nav.wallet": "Wallet",
    "nav.alerts": "Alerts",
    "nav.points": "Points",
    "nav.operations": "Ops",
    "nav.proxy": "Proxy",
    "nav.deploy": "Deploy",
    "search.placeholder": "Search tokens by name or mint...",
    "tooltip.theme": "Toggle theme",
    "tooltip.layout": "Toggle Layout Direction",
    "tooltip.notifications": "Notifications",
    "tooltip.tps": "Solana Mainnet-Beta Status",
    "tooltip.solPrice": "Current SOL Price",
    "tooltip.connectedUsers": "Users connected to the platform",
    "tooltip.phantomBalance": "Phantom wallet balance",
    "tooltip.pumpPortalBalance": "PumpPortal trading wallet balance",
    "tooltip.copyAddress": "Copy wallet address",
    "status.live": "LIVE",
    "status.conn": "CONN",
    "status.reconn": "RECONN",
    "status.err": "ERR",
    "status.off": "OFF",
    "panel.pumpLiquidity": "Pump Liquidity",
    "panel.live": "Live",
    "panel.connecting": "Connecting...",
    "panel.offline": "Offline",
    "panel.standard": "Standard",
    "panel.advanced": "Advanced",
    "panel.collapse": "Collapse",
    "panel.expand": "Expand",
    "panel.buy": "Buy",
    "panel.sell": "Sell",
    "panel.myPosition": "My Position",
    "panel.openPositions": "Open Positions",
    "panel.otherWallets": "Other Wallet Positions",
    "panel.walletSol": "Wallet SOL",
    "panel.tokenBalance": "Token Balance",
    "panel.marketPrice": "Market Price",
    "panel.tokenSupply": "Token Supply",
    "panel.onChainSupply": "On-chain supply",
    "panel.loading": "Loading...",
    "panel.updatedAt": "Updated {time}",
    "panel.noPositions": "No open positions found.",
    "panel.noSubWallets": "No sub-wallets generated yet.",
    "panel.generatedWallets": "Generated Wallets ({count})",
    "panel.close": "Close",
    "panel.netSize": "Net Size",
    "panel.direction": "Direction",
    "panel.value": "Value",
    "panel.pnl": "P&L",
    "panel.seen": "Seen",
    "signalEvidence.title": "Signal Evidence",
    "signalEvidence.syncing": "Syncing On-Chain History...",
    "signalEvidence.empty": "No Tape Prints Yet",
    "signalEvidence.liveTape": "Live Tape Print",
    "signalEvidence.curated": "Curated items highlighted",
    "signalEvidence.time": "Time",
    "signalEvidence.type": "Type",
    "signalEvidence.wallet": "Wallet",
    "signalEvidence.size": "Size",
    "signalEvidence.intel": "Intel",
    "signalEvidence.confidence": "Confidence",
    "social.timeline": "Timeline",
    "social.followers": "Followers",
    "social.retweets": "RT's",
    "social.likes": "Likes",
    "social.loadingTimeline": "Loading timeline…",
    "wallet.xAuthTitle": "X sign-in",
    "wallet.xPrompt": "Connect X before generating a wallet account.",
    "wallet.xConnectedLabel": "Connected as @{handle}",
    "wallet.xHandlePlaceholder": "Enter your X handle",
    "wallet.connectX": "Connect X",
    "wallet.disconnectX": "Disconnect",
    "wallet.xConnected": "X connected — wallet generation is unlocked.",
    "wallet.xLoginRequired": "Connect X first to generate a wallet account.",
    "wallet.generateAccount": "Generate New Account",
    "wallet.send": "Send",
    "wallet.receive": "Receive",
    "wallet.amount": "Amount",
    "wallet.recipient": "Recipient Address",
    "wallet.confirmSend": "Confirm Send",
    "wallet.currency": "Currency",
    "wallet.deposit": "Deposit",
    "ops.composeTitle": "Drop a callout",
    "ops.composeHint": "Share a market callout with an on-chain position snapshot.",
    "ops.coinPlaceholder": "Coin or mint",
    "ops.messagePlaceholder": "What are you calling?",
    "ops.imagePlaceholder": "Image URL (optional)",
    "ops.positionType": "Open position",
    "ops.positionSnapshot": "Open position snapshot",
    "ops.size": "Size",
    "ops.entry": "Entry",
    "ops.notes": "Notes",
    "ops.walletAddress": "Trade wallet address (optional)",
    "ops.tradeWallet": "Trade wallet",
    "ops.copyWallet": "Copy wallet",
    "ops.copyWalletNotice": "Wallet address copied",
    "ops.sourceAuto": "Auto",
    "ops.autoReasonLabel": "Source",
    "ops.positionValue": "Position value: ${value}",
    "ops.post": "Post callout",
    "ops.copyTrade": "Copy trade",
    "ops.copying": "Copied",
    "ops.empty": "No callouts yet. Be the first to publish one.",
    "ops.positionLong": "Long",
    "ops.positionShort": "Short",
    "ops.positionNeutral": "Neutral",

    // Sidebar & Trading
    "trading.mode.paper": "PAPER",
    "trading.mode.real": "REAL",
    "trading.manualSell": "Manual Sell",
    "trading.stopSession": "stop session to edit",
    "trading.live": "live",

    // Order Book
    "orderbook.title": "Order book",
    "orderbook.subtitle": "Laserstream trades for this mint",
    "orderbook.total": "Total",
    "orderbook.buys": "Buys",
    "orderbook.sells": "Sells",
    "orderbook.buyPct": "Buy%",
    "orderbook.volume": "Volume",
    "orderbook.buyVol": "Buy Vol",
    "orderbook.sellVol": "Sell Vol",
    "orderbook.recentPrints": "Recent Prints ({count})",
    "orderbook.buy": "Buy",
    "orderbook.sell": "Sell",
    "orderbook.waiting": "Waiting for trades on this mint… If the token is illiquid, prints may be sparse.",

    // Chart & Analytics
    "chart.suggestLines": "Suggest lines",
    "chart.axis.mc": "MC",
    "chart.axis.price": "Price",
    "chart.timeframe": "Timeframe",
    "chart.timezone": "Timezone",
    "chart.loading": "Loading chart data...",
    "chart.error": "Error loading chart",

    // Nursery Panel
    "nursery.tab.yours": "YOURS",
    "nursery.tab.new": "New",
    "nursery.tab.grad": "Grad",
    "nursery.tab.bonded": "Bonded",
    "nursery.tab.old": "Old",
    "nursery.tab.runners": "Runners",
    "nursery.tab.devs": "Devs",
    "nursery.sub.tradable": "Tradable",
    "nursery.sub.checked": "Checked",
    "nursery.sub.blocked": "Blocked",
    "nursery.sub.unchecked": "Unchecked",
    "nursery.sub.stale": "Stale",
    "nursery.sort.label": "Sort by:",
    "nursery.sort.heat": "🔥 Heat",
    "nursery.sort.coins": "🪙 Coins",
    "nursery.sort.ath": "📈 ATH",
    "nursery.sort.age": "Age",
    "nursery.sort.mc": "MC",
    "nursery.sort.vol": "Vol/Bids",
    "nursery.sort.highToLow": "High → Low",
    "nursery.sort.lowToHigh": "Low → High",
    "nursery.combinedReturn": "Combined Potential Return",
    "nursery.smartDeploy": "Smart Deploy",
    "nursery.smartDeployDesc": "Go beyond basic launches. Embed custom Rust hooks, protect your liquidity with Anti-Snipe logic, and unlock exclusive Deployer Intelligence.",
    "nursery.deployNow": "Deploy Now",
    "nursery.waitingFeed": "Waiting for feed...",
    "nursery.noTokensMatch": "No tokens match the current filter",
    "nursery.search.placeholder": "Search 400k+ pairs, dev, mint...",

    // Signals Panel
    "signals.title": "Signals",
    "signals.filter": "Filter",
    "signals.scanFilter": "Scan Filter",
    "signals.confidence": "Confidence",
    "signals.whaleSol": "Whale SOL",
    "signals.bonding": "Bonding",
    "signals.favSearches": "Favorites & Searches",
    "signals.items": "items",
    "signals.monitoring": "Monitoring global tape for\nhigh-intensity momentum...",
    "signals.age": "Age",
    "signals.whaleVol": "Whale Vol",
    "signals.walletIntel": "Wallet Intel",
    "signals.standardView": "Standard View",
    "signals.lilyView": "Lily Grid View",

    // Search
    "search.recentSearches": "Recent Searches",
    "search.priceMC": "Price / MC",
    "search.liqVol": "Liq / Vol(24h)",
    "search.holders": "Holders",
    "search.priceUsd": "Price USD",
    "search.liquidity": "Liquidity",
    "search.description": "Description",
    "search.backToResults": "Back to results",
    "search.copyMint": "Copy Mint",
    "search.tokenInfo": "Token Info",

    // Shell panels
    "shell.collapseLeft": "Collapse left panel",
    "shell.expandLeft": "Expand left panel",
    "shell.collapseSignals": "Collapse signals panel",
    "shell.expandSignals": "Expand signals panel",
    "shell.collapseRight": "Collapse right panel",
    "shell.expandRight": "Expand right panel",
    "shell.agentOps": "Agent Ops",
    "shell.switchToOps": "Switch to Agent Operations",
    "shell.switchToAI": "Switch to AI",

    // Sidebar
    "sidebar.svix": "SVIX",

    // Advanced Trading & Sync features
    "wallet.showKey": "Show",
    "wallet.hideKey": "Hide",
    "wallet.advancedView": "Advanced View Settings",
    "wallet.secretKey": "Secret Private Key (Base58)",
    "wallet.enableOffline": "Enable Offline Copy Trading & Limit Orders",
    "wallet.syncStatus": "Offline Sync Status",
    "wallet.syncButton": "Sync Wallet to Server",
    "wallet.unsyncButton": "Unsync Wallet from Server",
    "wallet.offlineActive": "Offline Active",
    "wallet.offlineInactive": "Offline Inactive",
    "wallet.copyTradeSetup": "Offline Copy Trading Setup",
    "wallet.targetAddress": "Target Wallet Address",
    "wallet.copyAmount": "Buy Amount (SOL)",
    "wallet.maxDaily": "Max Daily (SOL)",
    "wallet.addWhale": "Add Target",
    "wallet.activeWhales": "Active Copy Targets",
    "limit.title": "Limit Order",
    "limit.triggerType": "Trigger Type",
    "limit.triggerValue": "Target Value",
    "limit.amount": "Order Amount",
    "limit.placeOrder": "Place Limit Order",
    "limit.activeOrders": "Active Limit Orders",
    "limit.noOrders": "No active limit orders.",
    "alerts.panelTitle": "Alerts Hub",
    "alerts.createTitle": "Create Alert Trigger",
    "alerts.walletLabel": "Wallet Address",
    "alerts.priceLabel": "Price Alert (SOL)",
    "alerts.directionLabel": "Direction",
    "alerts.minSizeLabel": "Min Trade Size (SOL)",
    "alerts.liveFeed": "Live Alerts Stream",
    "points.title": "Claw Points Ledger",
    "points.tasksTitle": "Gamified Tasks Checklist",
    "points.leaderboardTitle": "Global Leaderboard",
    "airdrop.title": "Airdrop Lists",
    "airdrop.extract": "Extract Current Token",
    "airdrop.extracting": "Extracting...",
    "airdrop.desc": "Extract token holders from existing tokens to create airdrop lists. You can then link a wallet to an airdrop list in the Playground using an \"airdrop\" edge.",
    "airdrop.empty": "No airdrop lists yet.",
    "airdrop.remove": "Remove",
    "airdrop.recipients": "{count} recipients",
    "airdrop.more": "+ {count} more",
    "airdrop.retry": "Retry",
    "airdrop.retrying": "Retrying...",
    "airdrop.walletsCount": "Wallets",
    "toast.justDeployed": "Just deployed",
    "toast.massDeployment": "{count} mass deployment detected",
    "toast.more": "+ {count} more",
    "nursery.topRunner": "Top Runner",
    "nursery.heatMultiplier": "Heat Multiplier",
    "nursery.currentMc": "Current MC",
    "nursery.ath": "All Time High",
    "nursery.vol24h": "24h Vol",
    "nursery.tokenAge": "Token Age",
    "nursery.lastTx": "Last Tx",
    "nursery.justNow": "Just now",
    "nursery.ago": "ago",
    "nursery.heatScoreLabel": "Heat / Runner Score",
    "nursery.heatScoreDesc": "A dynamic momentum metric scoring tokens based on 5-minute rolling volume, live market cap progression, and active trader count. Tokens rapidly 'cool down' and drop off the feed if trading volume stalls.",
    "chart.fvg": "FVG",
    "chart.rugged": "Rugged",
    "pool.mktCap": "Mkt Cap",
    "pool.curve": "Curve",
    "pool.unsoldValue": "Unsold (Value)",
    "pool.totalBought": "Total Bought",
    "pool.totalSold": "Total Sold",
    "pool.netPnl": "Net PnL (SOL)",
  },
  es: {
    // Top Chrome & Shell
    "nav.dashboard": "Panel",
    "nav.setup": "Configuración",
    "nav.code": "Código",
    "nav.nursery": "Criadero",
    "nav.alpha": "Alfa",
    "nav.wallet": "Billetera",
    "nav.proxy": "Proxy",
    "nav.deploy": "Desplegar",
    "search.placeholder": "Buscar tokens por nombre o dirección...",
    "tooltip.theme": "Cambiar tema",
    "tooltip.layout": "Cambiar dirección de diseño",
    "tooltip.notifications": "Notificaciones",
    "tooltip.tps": "Estado de la red principal de Solana",
    "tooltip.solPrice": "Precio actual de SOL",
    "tooltip.connectedUsers": "Usuarios conectados a la plataforma",
    "tooltip.phantomBalance": "Saldo de la billetera Phantom",
    "tooltip.pumpPortalBalance": "Saldo de la billetera PumpPortal",
    "tooltip.copyAddress": "Copiar dirección de billetera",
    "status.live": "VIVO",
    "status.conn": "CONEX",
    "status.reconn": "RECONEX",
    "status.err": "ERROR",
    "status.off": "APAGADO",
    "panel.pumpLiquidity": "Liquidez de bomba",
    "panel.live": "En vivo",
    "panel.connecting": "Conectando...",
    "panel.offline": "Desconectado",
    "panel.standard": "Estándar",
    "panel.advanced": "Avanzado",
    "panel.collapse": "Contraer",
    "panel.expand": "Expandir",
    "panel.buy": "Comprar",
    "panel.sell": "Vender",
    "panel.myPosition": "Mi posición",
    "panel.openPositions": "Posiciones abiertas",
    "panel.otherWallets": "Otras posiciones de wallets",
    "panel.walletSol": "SOL del wallet",
    "panel.tokenBalance": "Saldo del token",
    "panel.marketPrice": "Precio de mercado",
    "panel.tokenSupply": "Suministro del token",
    "panel.onChainSupply": "Suministro on-chain",
    "panel.loading": "Cargando...",
    "panel.updatedAt": "Actualizado {time}",
    "panel.noPositions": "No se encontraron posiciones abiertas.",
    "panel.noSubWallets": "Aún no se han generado sub-wallets.",
    "panel.generatedWallets": "Wallets generadas ({count})",
    "panel.close": "Cerrar",
    "panel.netSize": "Tamaño neto",
    "panel.direction": "Dirección",
    "panel.value": "Valor",
    "panel.pnl": "Ganancia/Pérdida",
    "panel.seen": "Visto",
    "signalEvidence.title": "Evidencia de señal",
    "signalEvidence.syncing": "Sincronizando historial on-chain...",
    "signalEvidence.empty": "Aún no hay impresiones de cinta",
    "signalEvidence.liveTape": "Impresión en vivo",
    "signalEvidence.curated": "Elementos seleccionados resaltados",
    "signalEvidence.time": "Hora",
    "signalEvidence.type": "Tipo",
    "signalEvidence.wallet": "Wallet",
    "signalEvidence.size": "Tamaño",
    "signalEvidence.intel": "Intel",
    "signalEvidence.confidence": "Confianza",
    "social.timeline": "Cronología",
    "social.followers": "Seguidores",
    "social.retweets": "RT",
    "social.likes": "Me gusta",
    "social.loadingTimeline": "Cargando cronología…",
    "wallet.xAuthTitle": "Iniciar sesión en X",
    "wallet.xPrompt": "Conecta X antes de generar una cuenta de billetera.",
    "wallet.xConnectedLabel": "Conectado como @{handle}",
    "wallet.xHandlePlaceholder": "Ingresa tu usuario de X",
    "wallet.connectX": "Conectar X",
    "wallet.disconnectX": "Desconectar",
    "wallet.xConnected": "X conectado — generación de billetera desbloqueada.",
    "wallet.xLoginRequired": "Conecta X primero para generar una cuenta de billetera.",
    "wallet.generateAccount": "Generar Nueva Cuenta",
    "wallet.send": "Enviar",
    "wallet.receive": "Recibir",
    "wallet.amount": "Monto",
    "wallet.recipient": "Dirección Destino",
    "wallet.confirmSend": "Confirmar Envío",
    "wallet.currency": "Moneda",
    "wallet.deposit": "Depositar",
    "ops.composeTitle": "Lanzar un llamado",
    "ops.composeHint": "Comparte un llamado del mercado con una captura de posición en cadena.",
    "ops.coinPlaceholder": "Moneda o contrato",
    "ops.messagePlaceholder": "¿Qué estás llamando?",
    "ops.imagePlaceholder": "URL de la imagen (opcional)",
    "ops.positionType": "Posición abierta",
    "ops.positionSnapshot": "Captura de posición",
    "ops.size": "Tamaño",
    "ops.entry": "Entrada",
    "ops.notes": "Notas",
    "ops.walletAddress": "Dirección de billetera de intercambio (opcional)",
    "ops.tradeWallet": "Billetera de intercambio",
    "ops.copyWallet": "Copiar billetera",
    "ops.copyWalletNotice": "Dirección de billetera copiada",
    "ops.sourceAuto": "Auto",
    "ops.autoReasonLabel": "Fuente",
    "ops.positionValue": "Valor de la posición: ${value}",
    "ops.post": "Publicar llamado",
    "ops.copyTrade": "Copiar intercambio",
    "ops.copying": "Copiado",
    "ops.empty": "Aún no hay llamados. Sé el primero en publicar uno.",
    "ops.positionLong": "Largo",
    "ops.positionShort": "Corto",
    "ops.positionNeutral": "Neutral",
    // Sidebar & Trading
    "trading.mode.paper": "SIMULADO",
    "trading.mode.real": "REAL",
    "trading.manualSell": "Venta Manual",
    "trading.stopSession": "detener sesión para editar",
    "trading.live": "en vivo",

    // Order Book
    "orderbook.title": "Libro de órdenes",
    "orderbook.subtitle": "Transacciones de Laserstream para este token",
    "orderbook.total": "Total",
    "orderbook.buys": "Compras",
    "orderbook.sells": "Ventas",
    "orderbook.buyPct": "% Compra",
    "orderbook.volume": "Volumen",
    "orderbook.buyVol": "Vol. Compra",
    "orderbook.sellVol": "Vol. Venta",
    "orderbook.recentPrints": "Transacciones recientes ({count})",
    "orderbook.buy": "Comprar",
    "orderbook.sell": "Vender",
    "orderbook.waiting": "Esperando transacciones de este token... Si el token tiene poca liquidez, las transacciones pueden ser escasas.",

    // Chart & Analytics
    "chart.suggestLines": "Sugerir líneas",
    "chart.axis.mc": "Cap. de mercado",
    "chart.axis.price": "Precio",
    "chart.timeframe": "Temporalidad",
    "chart.timezone": "Zona horaria",
    "chart.loading": "Cargando datos del gráfico...",
    "chart.error": "Error al cargar el gráfico",

    // Nursery Panel
    "nursery.tab.yours": "TUYOS",
    "nursery.tab.new": "Nuevo",
    "nursery.tab.grad": "Graduado",
    "nursery.tab.bonded": "Vinculado",
    "nursery.tab.old": "Antiguo",
    "nursery.tab.runners": "Corredores",
    "nursery.tab.devs": "Desarrolladores",
    "nursery.sub.tradable": "Negociable",
    "nursery.sub.checked": "Verificado",
    "nursery.sub.blocked": "Bloqueado",
    "nursery.sub.unchecked": "Sin verificar",
    "nursery.sub.stale": "Obsoleto",
    "nursery.sort.label": "Ordenar por:",
    "nursery.sort.heat": "🔥 Calor",
    "nursery.sort.coins": "🪙 Coins",
    "nursery.sort.ath": "📈 ATH",
    "nursery.sort.age": "Edad",
    "nursery.sort.mc": "Cap.",
    "nursery.sort.vol": "Vol/Ofertas",
    "nursery.sort.highToLow": "Alto → Bajo",
    "nursery.sort.lowToHigh": "Bajo → Alto",
    "nursery.combinedReturn": "Retorno potencial combinado",
    "nursery.smartDeploy": "Despliegue inteligente",
    "nursery.smartDeployDesc": "Ve más allá de los lanzamientos básicos. Integra hooks Rust personalizados, protege tu liquidez con lógica Anti-Snipe y desbloquea inteligencia de Deployer exclusiva.",
    "nursery.deployNow": "Desplegar ahora",
    "nursery.waitingFeed": "Esperando señal...",
    "nursery.noTokensMatch": "Ningún token coincide con el filtro actual",
    "nursery.search.placeholder": "Buscar más de 400k pares, dev, mint...",

    // Signals Panel
    "signals.title": "Señales",
    "signals.filter": "Filtro",
    "signals.scanFilter": "Filtro de escaneo",
    "signals.confidence": "Confianza",
    "signals.whaleSol": "SOL de ballena",
    "signals.bonding": "Vinculación",
    "signals.favSearches": "Favoritos y búsquedas",
    "signals.items": "elementos",
    "signals.monitoring": "Monitoreando la cinta global en busca de\nimpulso de alta intensidad...",
    "signals.age": "Edad",
    "signals.whaleVol": "Vol. ballena",
    "signals.walletIntel": "Intel de billetera",
    "signals.standardView": "Vista estándar",
    "signals.lilyView": "Vista de cuadrícula Lily",

    // Search
    "search.recentSearches": "Búsquedas recientes",
    "search.priceMC": "Precio / Cap.",
    "search.liqVol": "Liq / Vol(24h)",
    "search.holders": "Titulares",
    "search.priceUsd": "Precio USD",
    "search.liquidity": "Liquidez",
    "search.description": "Descripción",
    "search.backToResults": "Volver a resultados",
    "search.copyMint": "Copiar Mint",
    "search.tokenInfo": "Info del token",

    // Shell panels
    "shell.collapseLeft": "Contraer panel izquierdo",
    "shell.expandLeft": "Expandir panel izquierdo",
    "shell.collapseSignals": "Contraer panel de señales",
    "shell.expandSignals": "Expandir panel de señales",
    "shell.collapseRight": "Contraer panel derecho",
    "shell.expandRight": "Expandir panel derecho",
    "shell.agentOps": "Ops de agente",
    "shell.switchToOps": "Cambiar a operaciones de agente",
    "shell.switchToAI": "Cambiar a IA",

    // Sidebar
    "sidebar.svix": "SVIX",
    "airdrop.title": "Listas de Airdrops",
    "airdrop.extract": "Extraer Token Actual",
    "airdrop.extracting": "Extrayendo...",
    "airdrop.desc": "Extrae los poseedores de tokens existentes para crear listas de airdrops. Luego puedes vincular una billetera a una lista de airdrops en el Playground usando una arista \"airdrop\".",
    "airdrop.empty": "Aún no hay listas de airdrops.",
    "airdrop.remove": "Eliminar",
    "airdrop.recipients": "{count} destinatarios",
    "airdrop.more": "+ {count} más",
    "airdrop.retry": "Reintentar",
    "airdrop.retrying": "Reintentando...",
    "airdrop.walletsCount": "Billeteras",
    "toast.justDeployed": "Recién desplegado",
    "toast.massDeployment": "{count} despliegues masivos detectados",
    "toast.more": "+ {count} más",
    "nursery.topRunner": "Mejor Corredor",
    "nursery.heatMultiplier": "Multiplicador de Calor",
    "nursery.currentMc": "Cap. Actual",
    "nursery.ath": "Máximo Histórico",
    "nursery.vol24h": "Vol 24h",
    "nursery.tokenAge": "Edad del Token",
    "nursery.lastTx": "Última Tx",
    "nursery.justNow": "Justo ahora",
    "nursery.ago": "hace",
    "nursery.heatScoreLabel": "Puntuación de Calor / Corredor",
    "nursery.heatScoreDesc": "Una métrica de impulso dinámico que califica tokens basándose en volumen móvil de 5 minutos, progresión en vivo de capitalización y número de operadores activos. Los tokens se 'enfrían' rápidamente y desaparecen del feed si el volumen de operaciones se estanca.",
    "chart.fvg": "FVG",
    "chart.rugged": "Rugpull",
    "pool.mktCap": "Cap. Mkt",
    "pool.curve": "Curva",
    "pool.unsoldValue": "No Vendido (Valor)",
    "pool.totalBought": "Total Comprado",
    "pool.totalSold": "Total Vendido",
    "pool.netPnl": "PnL Neto (SOL)",
  },
  zh: {
    // Top Chrome & Shell
    "nav.dashboard": "仪表板",
    "nav.setup": "设置",
    "nav.code": "代码",
    "nav.nursery": "育儿室",
    "nav.alpha": "阿尔法",
    "nav.wallet": "钱包",
    "nav.proxy": "代理",
    "nav.deploy": "部署",
    "search.placeholder": "通过名称或合约地址搜索代币...",
    "tooltip.theme": "切换主题",
    "tooltip.layout": "切换布局方向",
    "tooltip.notifications": "通知",
    "tooltip.tps": "Solana 主网状态",
    "tooltip.solPrice": "当前 SOL 价格",
    "tooltip.connectedUsers": "连接到平台的用户",
    "tooltip.phantomBalance": "Phantom 钱包余额",
    "tooltip.pumpPortalBalance": "PumpPortal 交易钱包余额",
    "tooltip.copyAddress": "复制钱包地址",
    "status.live": "在线",
    "status.conn": "连接中",
    "status.reconn": "重连中",
    "status.err": "错误",
    "status.off": "离线",
    "panel.pumpLiquidity": "泵池流动性",
    "panel.live": "实时",
    "panel.connecting": "连接中...",
    "panel.offline": "离线",
    "panel.standard": "标准",
    "panel.advanced": "高级",
    "panel.collapse": "收起",
    "panel.expand": "展开",
    "panel.buy": "买入",
    "panel.sell": "卖出",
    "panel.myPosition": "我的仓位",
    "panel.openPositions": "未平仓位",
    "panel.otherWallets": "其他钱包仓位",
    "panel.walletSol": "钱包 SOL",
    "panel.tokenBalance": "代币余额",
    "panel.marketPrice": "市场价格",
    "panel.tokenSupply": "代币供应量",
    "panel.onChainSupply": "链上供应量",
    "panel.loading": "加载中...",
    "panel.updatedAt": "更新于 {time}",
    "panel.noPositions": "没有未平仓位。",
    "panel.noSubWallets": "尚未生成子钱包。",
    "panel.generatedWallets": "已生成钱包 ({count})",
    "panel.close": "平仓",
    "panel.netSize": "净头寸",
    "panel.direction": "方向",
    "panel.value": "价值",
    "panel.pnl": "盈亏",
    "panel.seen": "最近看到",
    "signalEvidence.title": "信号证据",
    "signalEvidence.syncing": "同步链上历史...",
    "signalEvidence.empty": "暂无实时打印",
    "signalEvidence.liveTape": "实时打印",
    "signalEvidence.curated": "已精选项目高亮显示",
    "signalEvidence.time": "时间",
    "signalEvidence.type": "类型",
    "signalEvidence.wallet": "钱包",
    "signalEvidence.size": "大小",
    "signalEvidence.intel": "情报",
    "signalEvidence.confidence": "置信度",
    "social.timeline": "时间线",
    "social.followers": "粉丝",
    "social.retweets": "转推",
    "social.likes": "点赞",
    "social.loadingTimeline": "正在加载时间线…",
    "wallet.xAuthTitle": "X 登录",
    "wallet.xPrompt": "生成钱包账户前请连接 X。",
    "wallet.xConnectedLabel": "已连接为 @{handle}",
    "wallet.xHandlePlaceholder": "输入您的 X 用户名",
    "wallet.connectX": "连接 X",
    "wallet.disconnectX": "断开连接",
    "wallet.xConnected": "X 已连接 — 钱包生成已解锁。",
    "wallet.xLoginRequired": "请先连接 X 以生成钱包账户。",
    "wallet.generateAccount": "生成新账户",
    "wallet.send": "发送",
    "wallet.receive": "接收",
    "wallet.amount": "金额",
    "wallet.recipient": "收款地址",
    "wallet.confirmSend": "确认发送",
    "wallet.currency": "货币",
    "wallet.deposit": "存款",
    "ops.composeTitle": "发布喊单",
    "ops.composeHint": "分享带有链上仓位快照的市场喊单。",
    "ops.coinPlaceholder": "代币或合约地址",
    "ops.messagePlaceholder": "您要喊什么单？",
    "ops.imagePlaceholder": "图片 URL（可选）",
    "ops.positionType": "未平仓位",
    "ops.positionSnapshot": "持仓快照",
    "ops.size": "规模",
    "ops.entry": "入场",
    "ops.notes": "备注",
    "ops.walletAddress": "交易钱包地址（可选）",
    "ops.tradeWallet": "交易钱包",
    "ops.copyWallet": "复制钱包",
    "ops.copyWalletNotice": "已复制钱包地址",
    "ops.sourceAuto": "自动",
    "ops.autoReasonLabel": "来源",
    "ops.positionValue": "仓位价值: ${value}",
    "ops.post": "发布喊单",
    "ops.copyTrade": "跟单",
    "ops.copying": "已复制",
    "ops.empty": "暂无喊单。成为第一个发布的人。",
    "ops.positionLong": "做多",
    "ops.positionShort": "做空",
    "ops.positionNeutral": "中性",
    // Sidebar & Trading
    "trading.mode.paper": "模拟交易",
    "trading.mode.real": "真实交易",
    "trading.manualSell": "手动卖出",
    "trading.stopSession": "停止运行以编辑",
    "trading.live": "实时",

    // Order Book
    "orderbook.title": "订单簿",
    "orderbook.subtitle": "此代币的 PumpPortal 交易记录",
    "orderbook.total": "总计",
    "orderbook.buys": "买入数",
    "orderbook.sells": "卖出数",
    "orderbook.buyPct": "买入%",
    "orderbook.volume": "交易量",
    "orderbook.buyVol": "买入量",
    "orderbook.sellVol": "卖出量",
    "orderbook.recentPrints": "最近交易 ({count})",
    "orderbook.buy": "买入",
    "orderbook.sell": "卖出",
    "orderbook.waiting": "等待该代币交易...如果代币流动性不足，交易可能会很稀疏。",

    // Chart & Analytics
    "chart.suggestLines": "推荐线条",
    "chart.axis.mc": "市值",
    "chart.axis.price": "价格",
    "chart.timeframe": "时间周期",
    "chart.timezone": "时区",
    "chart.loading": "加载图表数据中...",
    "chart.error": "加载图表错误",

    // Nursery Panel
    "nursery.tab.yours": "我的",
    "nursery.tab.new": "新币",
    "nursery.tab.grad": "毕业",
    "nursery.tab.bonded": "已绑定",
    "nursery.tab.old": "旧币",
    "nursery.tab.runners": "跑者",
    "nursery.tab.devs": "开发者",
    "nursery.sub.tradable": "可交易",
    "nursery.sub.checked": "已验证",
    "nursery.sub.blocked": "已屏蔽",
    "nursery.sub.unchecked": "未验证",
    "nursery.sub.stale": "过期",
    "nursery.sort.label": "排序：",
    "nursery.sort.heat": "🔥 热度",
    "nursery.sort.coins": "🪙 Coins",
    "nursery.sort.ath": "📈 ATH",
    "nursery.sort.age": "时间",
    "nursery.sort.mc": "市值",
    "nursery.sort.vol": "量/出价",
    "nursery.sort.highToLow": "从高到低",
    "nursery.sort.lowToHigh": "从低到高",
    "nursery.combinedReturn": "综合潜在回报",
    "nursery.smartDeploy": "智能部署",
    "nursery.smartDeployDesc": "超越基础发射。嵌入自定义 Rust 钩子，通过 Anti-Snipe 逻辑保护流动性，解锁独家部署者情报。",
    "nursery.deployNow": "立即部署",
    "nursery.waitingFeed": "等待数据源...",
    "nursery.noTokensMatch": "没有代币匹配当前筛选条件",
    "nursery.search.placeholder": "搜索40万+代币、开发者、合约...",

    // Signals Panel
    "signals.title": "信号",
    "signals.filter": "筛选",
    "signals.scanFilter": "扫描筛选",
    "signals.confidence": "置信度",
    "signals.whaleSol": "巨鲸 SOL",
    "signals.bonding": "绑定",
    "signals.favSearches": "收藏与搜索",
    "signals.items": "项",
    "signals.monitoring": "正在监控全球交易带\n寻找高强度动量...",
    "signals.age": "时间",
    "signals.whaleVol": "巨鲸交易量",
    "signals.walletIntel": "钱包情报",
    "signals.standardView": "标准视图",
    "signals.lilyView": "Lily 网格视图",

    // Search
    "search.recentSearches": "最近搜索",
    "search.priceMC": "价格 / 市值",
    "search.liqVol": "流动性 / 24h交易量",
    "search.holders": "持有人",
    "search.priceUsd": "美元价格",
    "search.liquidity": "流动性",
    "search.description": "描述",
    "search.backToResults": "返回结果",
    "search.copyMint": "复制 Mint",
    "search.tokenInfo": "代币信息",

    // Shell panels
    "shell.collapseLeft": "收起左面板",
    "shell.expandLeft": "展开左面板",
    "shell.collapseSignals": "收起信号面板",
    "shell.expandSignals": "展开信号面板",
    "shell.collapseRight": "收起右面板",
    "shell.expandRight": "展开右面板",
    "shell.agentOps": "代理操作",
    "shell.switchToOps": "切换到代理操作",
    "shell.switchToAI": "切换到 AI",

    // Sidebar
    "sidebar.svix": "SVIX",
    "airdrop.title": "空投列表",
    "airdrop.extract": "提取当前代币",
    "airdrop.extracting": "正在提取...",
    "airdrop.desc": "从现有代币中提取持有人以创建空投列表。然后，您可以使用 \"airdrop\" 边在游乐场中将钱包链接到空投列表。",
    "airdrop.empty": "尚无空投列表。",
    "airdrop.remove": "移除",
    "airdrop.recipients": "{count} 个接收者",
    "airdrop.more": "+ 还有 {count} 个",
    "airdrop.retry": "重试",
    "airdrop.retrying": "正在重试...",
    "airdrop.walletsCount": "钱包",
    "toast.justDeployed": "刚刚部署",
    "toast.massDeployment": "检测到 {count} 个大规模部署",
    "toast.more": "+ 还有 {count} 个",
    "nursery.topRunner": "最佳领跑者",
    "nursery.heatMultiplier": "热度倍数",
    "nursery.currentMc": "当前市值",
    "nursery.ath": "历史最高",
    "nursery.vol24h": "24小时交易量",
    "nursery.tokenAge": "代币年龄",
    "nursery.lastTx": "最新交易",
    "nursery.justNow": "刚刚",
    "nursery.ago": "前",
    "nursery.heatScoreLabel": "热度 / 领跑分数",
    "nursery.heatScoreDesc": "动态动量指标，基于5分钟滚动交易量、实时市值变化和活跃交易者数量为代币评分。如果交易量停滞，代币会迅速“冷却”并从信息流中掉落。",
    "chart.fvg": "公允价值缺口",
    "chart.rugged": "跑路",
    "pool.mktCap": "市值",
    "pool.curve": "曲线",
    "pool.unsoldValue": "未售出 (价值)",
    "pool.totalBought": "总买入",
    "pool.totalSold": "总卖出",
    "pool.netPnl": "净盈亏 (SOL)",
  },
  ja: {
    // Top Chrome & Shell
    "nav.dashboard": "ダッシュボード",
    "nav.setup": "設定",
    "nav.code": "コード",
    "nav.nursery": "ナーサリー",
    "nav.alpha": "アルファ",
    "nav.wallet": "ウォレット",
    "nav.proxy": "プロキシ",
    "nav.deploy": "デプロイ",
    "search.placeholder": "名前またはミントアドレスでトークンを検索...",
    "tooltip.theme": "テーマ切り替え",
    "tooltip.layout": "レイアウト方向の切り替え",
    "tooltip.notifications": "通知",
    "tooltip.tps": "Solana メインネットステータス",
    "tooltip.solPrice": "現在の SOL 価格",
    "tooltip.connectedUsers": "プラットフォームに接続中のユーザー",
    "tooltip.phantomBalance": "Phantom ウォレット残高",
    "tooltip.pumpPortalBalance": "PumpPortal 取引ウォレット残高",
    "tooltip.copyAddress": "ウォレットアドレスをコピー",
    "status.live": "稼働中",
    "status.conn": "接続中",
    "status.reconn": "再接続中",
    "status.err": "エラー",
    "status.off": "停止中",
    "panel.pumpLiquidity": "ポンプ流動性",
    "panel.live": "ライブ",
    "panel.connecting": "接続中...",
    "panel.offline": "オフライン",
    "panel.standard": "標準",
    "panel.advanced": "高度",
    "panel.collapse": "折りたたむ",
    "panel.expand": "展開",
    "panel.buy": "買う",
    "panel.sell": "売る",
    "panel.myPosition": "自分のポジション",
    "panel.openPositions": "保有ポジション",
    "panel.otherWallets": "他ウォレットのポジション",
    "panel.walletSol": "ウォレット SOL",
    "panel.tokenBalance": "トークン残高",
    "panel.marketPrice": "市場価格",
    "panel.tokenSupply": "トークン供給量",
    "panel.onChainSupply": "オンチェーン供給",
    "panel.loading": "読み込み中...",
    "panel.updatedAt": "更新 {time}",
    "panel.noPositions": "保有ポジションはありません。",
    "panel.noSubWallets": "サブウォレットはまだ生成されていません。",
    "panel.generatedWallets": "生成済みウォレット ({count})",
    "panel.close": "クローズ",
    "panel.netSize": "純サイズ",
    "panel.direction": "方向",
    "panel.value": "価値",
    "panel.pnl": "損益",
    "panel.seen": "確認時刻",
    "signalEvidence.title": "シグナル証拠",
    "signalEvidence.syncing": "オンチェーン履歴を同期中...",
    "signalEvidence.empty": "まだテープ印字はありません",
    "signalEvidence.liveTape": "ライブテープ印字",
    "signalEvidence.curated": "厳選した項目をハイライト",
    "signalEvidence.time": "時間",
    "signalEvidence.type": "タイプ",
    "signalEvidence.wallet": "ウォレット",
    "signalEvidence.size": "サイズ",
    "signalEvidence.intel": "インテル",
    "signalEvidence.confidence": "信頼度",
    "social.timeline": "タイムライン",
    "social.followers": "フォロワー",
    "social.retweets": "RT",
    "social.likes": "いいね",
    "social.loadingTimeline": "タイムラインを読み込み中…",
    "wallet.xAuthTitle": "X サインイン",
    "wallet.xPrompt": "ウォレットアカウントを生成する前に X に接続してください。",
    "wallet.xConnectedLabel": "@{handle} として接続中",
    "wallet.xHandlePlaceholder": "X ハンドルを入力",
    "wallet.connectX": "X に接続",
    "wallet.disconnectX": "切断",
    "wallet.xConnected": "X 接続完了 — ウォレット生成のロックが解除されました。",
    "wallet.xLoginRequired": "ウォレットアカウントを生成するには、まずXに接続してください。",
    "wallet.generateAccount": "新しいアカウントを生成",
    "wallet.send": "送信",
    "wallet.receive": "受信",
    "wallet.amount": "金額",
    "wallet.recipient": "宛先アドレス",
    "wallet.confirmSend": "送信を確認",
    "wallet.currency": "通貨",
    "wallet.deposit": "入金",
    "ops.composeTitle": "コールアウトを投稿",
    "ops.composeHint": "オンチェーンポジションのスナップショットと共にマーケットコールアウトを共有します。",
    "ops.coinPlaceholder": "コインまたはミント",
    "ops.messagePlaceholder": "何をコールしますか？",
    "ops.imagePlaceholder": "画像 URL (任意)",
    "ops.positionType": "オープンポジション",
    "ops.positionSnapshot": "ポジションスナップショット",
    "ops.size": "サイズ",
    "ops.entry": "エントリー",
    "ops.notes": "ノート",
    "ops.walletAddress": "トレードウォレットアドレス (任意)",
    "ops.tradeWallet": "トレードウォレット",
    "ops.copyWallet": "ウォレットをコピー",
    "ops.copyWalletNotice": "ウォレットアドレスをコピーしました",
    "ops.sourceAuto": "自動",
    "ops.autoReasonLabel": "ソース",
    "ops.positionValue": "ポジション価値: ${value}",
    "ops.post": "コールアウトを投稿",
    "ops.copyTrade": "トレードをコピー",
    "ops.copying": "コピーしました",
    "ops.empty": "コールアウトはまだありません。最初の投稿者になりましょう。",
    "ops.positionLong": "ロング",
    "ops.positionShort": "ショート",
    "ops.positionNeutral": "ニュートラル",
    // Sidebar & Trading
    "trading.mode.paper": "デモ取引",
    "trading.mode.real": "リアル取引",
    "trading.manualSell": "手動売却",
    "trading.stopSession": "編集するにはセッションを停止してください",
    "trading.live": "ライブ",

    // Order Book
    "orderbook.title": "オーダーブック",
    "orderbook.subtitle": "このトークンの PumpPortal 取引",
    "orderbook.total": "合計",
    "orderbook.buys": "買い",
    "orderbook.sells": "売り",
    "orderbook.buyPct": "買い割合",
    "orderbook.volume": "出来高",
    "orderbook.buyVol": "買い出来高",
    "orderbook.sellVol": "売り出来高",
    "orderbook.recentPrints": "最近の約定 ({count})",
    "orderbook.buy": "買い",
    "orderbook.sell": "売り",
    "orderbook.waiting": "このトークンの取引を待機中… 流動性が低い場合、約定履歴がまばらになることがあります。",

    // Chart & Analytics
    "chart.suggestLines": "ラインを提案",
    "chart.axis.mc": "時価総額",
    "chart.axis.price": "価格",
    "chart.timeframe": "時間足",
    "chart.timezone": "タイムゾーン",
    "chart.loading": "チャートデータを読み込み中...",
    "chart.error": "チャート読み込みエラー",

    // Nursery Panel
    "nursery.tab.yours": "あなたの",
    "nursery.tab.new": "新規",
    "nursery.tab.grad": "卒業",
    "nursery.tab.bonded": "ボンド済",
    "nursery.tab.old": "古い",
    "nursery.tab.runners": "ランナー",
    "nursery.tab.devs": "開発者",
    "nursery.sub.tradable": "取引可能",
    "nursery.sub.checked": "確認済",
    "nursery.sub.blocked": "ブロック済",
    "nursery.sub.unchecked": "未確認",
    "nursery.sub.stale": "古い",
    "nursery.sort.label": "並び替え：",
    "nursery.sort.heat": "🔥 ヒート",
    "nursery.sort.coins": "🪙 Coins",
    "nursery.sort.ath": "📈 ATH",
    "nursery.sort.age": "時間",
    "nursery.sort.mc": "時価総額",
    "nursery.sort.vol": "出来高/入札",
    "nursery.sort.highToLow": "高い → 低い",
    "nursery.sort.lowToHigh": "低い → 高い",
    "nursery.combinedReturn": "合計潜在リターン",
    "nursery.smartDeploy": "スマートデプロイ",
    "nursery.smartDeployDesc": "基本的なローンチを超えましょう。カスタム Rust フック、Anti-Snipe ロジックによる流動性保護、限定デプロイヤーインテリジェンスをアンロック。",
    "nursery.deployNow": "今すぐデプロイ",
    "nursery.waitingFeed": "フィード待機中...",
    "nursery.noTokensMatch": "現在のフィルターに一致するトークンはありません",
    "nursery.search.placeholder": "40万+ペア、開発者、ミントを検索...",

    // Signals Panel
    "signals.title": "シグナル",
    "signals.filter": "フィルター",
    "signals.scanFilter": "スキャンフィルター",
    "signals.confidence": "信頼度",
    "signals.whaleSol": "クジラ SOL",
    "signals.bonding": "ボンディング",
    "signals.favSearches": "お気に入りと検索",
    "signals.items": "件",
    "signals.monitoring": "グローバルテープを監視中\n高強度モメンタムを検出中...",
    "signals.age": "時間",
    "signals.whaleVol": "クジラ出来高",
    "signals.walletIntel": "ウォレットインテル",
    "signals.standardView": "標準ビュー",
    "signals.lilyView": "Lily グリッドビュー",

    // Search
    "search.recentSearches": "最近の検索",
    "search.priceMC": "価格 / 時価総額",
    "search.liqVol": "流動性 / 24h出来高",
    "search.holders": "ホルダー数",
    "search.priceUsd": "USD 価格",
    "search.liquidity": "流動性",
    "search.description": "説明",
    "search.backToResults": "結果に戻る",
    "search.copyMint": "Mint をコピー",
    "search.tokenInfo": "トークン情報",

    // Shell panels
    "shell.collapseLeft": "左パネルを折りたたむ",
    "shell.expandLeft": "左パネルを展開",
    "shell.collapseSignals": "シグナルパネルを折りたたむ",
    "shell.expandSignals": "シグナルパネルを展開",
    "shell.collapseRight": "右パネルを折りたたむ",
    "shell.expandRight": "右パネルを展開",
    "shell.agentOps": "エージェント操作",
    "shell.switchToOps": "エージェント操作に切り替え",
    "shell.switchToAI": "AI に切り替え",

    // Sidebar
    "sidebar.svix": "SVIX",
    "airdrop.title": "エアドロップリスト",
    "airdrop.extract": "現在のトークンを抽出",
    "airdrop.extracting": "抽出中...",
    "airdrop.desc": "既存のトークンからホルダーを抽出してエアドロップリストを作成します。その後、Playgroundで「airdrop」エッジを使用して、ウォレットをエアドロップリストにリンクできます。",
    "airdrop.empty": "エアドロップリストはまだありません。",
    "airdrop.remove": "削除",
    "airdrop.recipients": "{count} 人の受信者",
    "airdrop.more": "+ 他 {count} 件",
    "airdrop.retry": "再試行",
    "airdrop.retrying": "再試行中...",
    "airdrop.walletsCount": "ウォレット",
    "toast.justDeployed": "デプロイ直後",
    "toast.massDeployment": "{count} 件の大量デプロイを検出",
    "toast.more": "+ 他 {count} 件",
    "nursery.topRunner": "トップランナー",
    "nursery.heatMultiplier": "ヒートマルチプライヤー",
    "nursery.currentMc": "現在の時価総額",
    "nursery.ath": "過去最高値",
    "nursery.vol24h": "24時間出来高",
    "nursery.tokenAge": "トークン経過時間",
    "nursery.lastTx": "最新の取引",
    "nursery.justNow": "たった今",
    "nursery.ago": "前",
    "nursery.heatScoreLabel": "ヒート / ランナースコア",
    "nursery.heatScoreDesc": "5分間のローリング出来高、ライブ時価総額の進行状況、およびアクティブなトレーダー数に基づいてトークンをスコアリングする動的なモメンタム指標。取引量が停滞すると、トークンは急速に「クールダウン」し、フィードからドロップオフします。",
    "chart.fvg": "FVG",
    "chart.rugged": "ラグ",
    "pool.mktCap": "時価総額",
    "pool.curve": "カーブ",
    "pool.unsoldValue": "未売却 (価値)",
    "pool.totalBought": "総買付額",
    "pool.totalSold": "総売却額",
    "pool.netPnl": "純損益 (SOL)",
  },
  ru: {
    // Top Chrome & Shell
    "nav.dashboard": "Панель",
    "nav.setup": "Настройка",
    "nav.code": "Код",
    "nav.nursery": "Инкубатор",
    "nav.alpha": "Альфа",
    "nav.wallet": "Кошелек",
    "nav.proxy": "Прокси",
    "nav.deploy": "Деплой",
    "search.placeholder": "Поиск токенов по названию или адресу...",
    "tooltip.theme": "Переключить тему",
    "tooltip.layout": "Переключить направление макета",
    "tooltip.notifications": "Уведомления",
    "tooltip.tps": "Статус основной сети Solana",
    "tooltip.solPrice": "Текущая цена SOL",
    "tooltip.connectedUsers": "Подключенные пользователи",
    "tooltip.phantomBalance": "Баланс кошелька Phantom",
    "tooltip.pumpPortalBalance": "Баланс торгового кошелька PumpPortal",
    "tooltip.copyAddress": "Скопировать адрес кошелька",
    "status.live": "АКТИВ",
    "status.conn": "ПОДКЛ",
    "status.reconn": "ПЕРЕПОДКЛ",
    "status.err": "ОШИБ",
    "status.off": "ВЫКЛ",
    "panel.pumpLiquidity": "Ликвидность Pump",
    "panel.live": "Онлайн",
    "panel.connecting": "Подключение...",
    "panel.offline": "Отключено",
    "panel.standard": "Стандарт",
    "panel.advanced": "Расширенный",
    "panel.collapse": "Свернуть",
    "panel.expand": "Развернуть",
    "panel.buy": "Купить",
    "panel.sell": "Продать",
    "panel.myPosition": "Моя позиция",
    "panel.openPositions": "Открытые позиции",
    "panel.otherWallets": "Позиции других кошельков",
    "panel.walletSol": "SOL кошелька",
    "panel.tokenBalance": "Баланс токена",
    "panel.marketPrice": "Рыночная цена",
    "panel.tokenSupply": "Предложение токена",
    "panel.onChainSupply": "Ончейн-предложение",
    "panel.loading": "Загрузка...",
    "panel.updatedAt": "Обновлено {time}",
    "panel.noPositions": "Открытых позиций не найдено.",
    "panel.noSubWallets": "Под-кошельки еще не созданы.",
    "panel.generatedWallets": "Сгенерированные кошельки ({count})",
    "panel.close": "Закрыть",
    "panel.netSize": "Чистый размер",
    "panel.direction": "Направление",
    "panel.value": "Стоимость",
    "panel.pnl": "P&L",
    "panel.seen": "Видно",
    "signalEvidence.title": "Подтверждение сигнала",
    "signalEvidence.syncing": "Синхронизация ончейн-истории...",
    "signalEvidence.empty": "Печатей ленты пока нет",
    "signalEvidence.liveTape": "Живая лента",
    "signalEvidence.curated": "Отобранные элементы подсвечены",
    "signalEvidence.time": "Время",
    "signalEvidence.type": "Тип",
    "signalEvidence.wallet": "Кошелек",
    "signalEvidence.size": "Размер",
    "signalEvidence.intel": "Интеллект",
    "signalEvidence.confidence": "Уверенность",
    "social.timeline": "Лента",
    "social.followers": "Подписчики",
    "social.retweets": "Ретвиты",
    "social.likes": "Лайки",
    "social.loadingTimeline": "Загрузка ленты…",
    "wallet.xAuthTitle": "Вход через X",
    "wallet.xPrompt": "Подключите X перед созданием аккаунта кошелька.",
    "wallet.xConnectedLabel": "Подключено как @{handle}",
    "wallet.xHandlePlaceholder": "Введите ваш ник в X",
    "wallet.connectX": "Подключить X",
    "wallet.disconnectX": "Отключить",
    "wallet.xConnected": "X подключен — создание кошелька разблокировано.",
    "wallet.xLoginRequired": "Сначала подключите X, чтобы создать аккаунт кошелька.",
    "wallet.generateAccount": "Создать новый аккаунт",
    "ops.composeTitle": "Оставить сигнал",
    "ops.composeHint": "Поделитесь рыночным сигналом со снимком ончейн-позиции.",
    "ops.coinPlaceholder": "Монета или адрес",
    "ops.messagePlaceholder": "Что вы прогнозируете?",
    "ops.imagePlaceholder": "URL изображения (необязательно)",
    "ops.positionType": "Открытая позиция",
    "ops.positionSnapshot": "Снимок позиции",
    "ops.size": "Размер",
    "ops.entry": "Вход",
    "ops.notes": "Заметки",
    "ops.walletAddress": "Адрес торгового кошелька (необязательно)",
    "ops.tradeWallet": "Торговый кошелек",
    "ops.copyWallet": "Скопировать кошелек",
    "ops.copyWalletNotice": "Адрес кошелька скопирован",
    "ops.sourceAuto": "Авто",
    "ops.autoReasonLabel": "Источник",
    "ops.positionValue": "Стоимость позиции: ${value}",
    "ops.post": "Опубликовать сигнал",
    "ops.copyTrade": "Копировать сделку",
    "ops.copying": "Скопировано",
    "ops.empty": "Сигналов пока нет. Будьте первым, кто его опубликует.",
    "ops.positionLong": "Лонг",
    "ops.positionShort": "Шорт",
    "ops.positionNeutral": "Нейтрально",
    // Sidebar & Trading
    "trading.mode.paper": "ДЕМО",
    "trading.mode.real": "РЕАЛ",
    "trading.manualSell": "Ручная продажа",
    "trading.stopSession": "остановите сессию для редактирования",
    "trading.live": "в эфире",

    // Order Book
    "orderbook.title": "Книга ордеров",
    "orderbook.subtitle": "Сделки PumpPortal для этого токена",
    "orderbook.total": "Всего",
    "orderbook.buys": "Покупки",
    "orderbook.sells": "Продажи",
    "orderbook.buyPct": "% Покупок",
    "orderbook.volume": "Объем",
    "orderbook.buyVol": "Объем покупок",
    "orderbook.sellVol": "Объем продаж",
    "orderbook.recentPrints": "Последние сделки ({count})",
    "orderbook.buy": "Купить",
    "orderbook.sell": "Продать",
    "orderbook.waiting": "Ожидание сделок по этому токену… При низкой ликвидности сделки могут быть редкими.",

    // Chart & Analytics
    "chart.suggestLines": "Предложить линии",
    "chart.axis.mc": "Рыночная кап.",
    "chart.axis.price": "Цена",
    "chart.timeframe": "Таймфрейм",
    "chart.timezone": "Часовой пояс",
    "chart.loading": "Загрузка данных графика...",
    "chart.error": "Ошибка загрузки графика",

    // Nursery Panel
    "nursery.tab.yours": "ВАШИ",
    "nursery.tab.new": "Новые",
    "nursery.tab.grad": "Выпуск",
    "nursery.tab.bonded": "Связанные",
    "nursery.tab.old": "Старые",
    "nursery.tab.runners": "Бегуны",
    "nursery.tab.devs": "Разработчики",
    "nursery.sub.tradable": "Торгуемые",
    "nursery.sub.checked": "Проверенные",
    "nursery.sub.blocked": "Заблокированные",
    "nursery.sub.unchecked": "Не проверено",
    "nursery.sub.stale": "Устаревшие",
    "nursery.sort.label": "Сортировка:",
    "nursery.sort.heat": "🔥 Жара",
    "nursery.sort.coins": "🪙 Coins",
    "nursery.sort.ath": "📈 ATH",
    "nursery.sort.age": "Возраст",
    "nursery.sort.mc": "Кап.",
    "nursery.sort.vol": "Объем/Ставки",
    "nursery.sort.highToLow": "Выс. → Низ.",
    "nursery.sort.lowToHigh": "Низ. → Выс.",
    "nursery.combinedReturn": "Совокупная потенциальная доходность",
    "nursery.smartDeploy": "Умный деплой",
    "nursery.smartDeployDesc": "Выйдите за рамки базовых запусков. Встраивайте пользовательские Rust-хуки, защищайте ликвидность логикой Anti-Snipe и получите эксклюзивную аналитику деплоера.",
    "nursery.deployNow": "Деплой сейчас",
    "nursery.waitingFeed": "Ожидание ленты...",
    "nursery.noTokensMatch": "Нет токенов, соответствующих текущему фильтру",
    "nursery.search.placeholder": "Поиск по 400k+ парам, dev, mint...",

    // Signals Panel
    "signals.title": "Сигналы",
    "signals.filter": "Фильтр",
    "signals.scanFilter": "Фильтр сканирования",
    "signals.confidence": "Уверенность",
    "signals.whaleSol": "Кит SOL",
    "signals.bonding": "Бондинг",
    "signals.favSearches": "Избранное и поиск",
    "signals.items": "элементов",
    "signals.monitoring": "Мониторинг глобальной ленты\nв поисках высокоинтенсивного моментума...",
    "signals.age": "Возраст",
    "signals.whaleVol": "Объем китов",
    "signals.walletIntel": "Аналитика кошелька",
    "signals.standardView": "Стандартный вид",
    "signals.lilyView": "Сетка Lily",

    // Search
    "search.recentSearches": "Недавние поиски",
    "search.priceMC": "Цена / Кап.",
    "search.liqVol": "Лик. / Объем(24ч)",
    "search.holders": "Держатели",
    "search.priceUsd": "Цена USD",
    "search.liquidity": "Ликвидность",
    "search.description": "Описание",
    "search.backToResults": "Назад к результатам",
    "search.copyMint": "Копировать Mint",
    "search.tokenInfo": "Инфо о токене",

    // Shell panels
    "shell.collapseLeft": "Свернуть левую панель",
    "shell.expandLeft": "Развернуть левую панель",
    "shell.collapseSignals": "Свернуть панель сигналов",
    "shell.expandSignals": "Развернуть панель сигналов",
    "shell.collapseRight": "Свернуть правую панель",
    "shell.expandRight": "Развернуть правую панель",
    "shell.agentOps": "Операции агента",
    "shell.switchToOps": "Перейти к операциям агента",
    "shell.switchToAI": "Перейти к AI",

    // Sidebar
    "sidebar.svix": "SVIX",
    "airdrop.title": "Списки аирдропов",
    "airdrop.extract": "Извлечь текущий токен",
    "airdrop.extracting": "Извлечение...",
    "airdrop.desc": "Извлекайте держателей из существующих токенов для создания списков аирдропов. Затем вы можете связать кошелек со списком аирдропов в Playground, используя связь \"airdrop\".",
    "airdrop.empty": "Списков аирдропов пока нет.",
    "airdrop.remove": "Удалить",
    "airdrop.recipients": "{count} получателей",
    "airdrop.more": "+ еще {count}",
    "airdrop.retry": "Повторить",
    "airdrop.retrying": "Повторение...",
    "airdrop.walletsCount": "Кошельки",
  },
  de: {
    // Top Chrome & Shell
    "nav.dashboard": "Dashboard",
    "nav.setup": "Einrichtung",
    "nav.code": "Code",
    "nav.nursery": "Nursery",
    "nav.alpha": "Alpha",
    "nav.wallet": "Wallet",
    "nav.proxy": "Proxy",
    "nav.deploy": "Bereitstellen",
    "search.placeholder": "Token nach Name oder Mint suchen...",
    "tooltip.theme": "Design umschalten",
    "tooltip.layout": "Layout-Richtung umschalten",
    "tooltip.notifications": "Benachrichtigungen",
    "tooltip.tps": "Solana Mainnet-Beta Status",
    "tooltip.solPrice": "Aktueller SOL-Preis",
    "tooltip.connectedUsers": "Verbundene Benutzer",
    "tooltip.phantomBalance": "Phantom Wallet Guthaben",
    "tooltip.pumpPortalBalance": "PumpPortal Trading Wallet Guthaben",
    "tooltip.copyAddress": "Wallet-Adresse kopieren",
    "status.live": "LIVE",
    "status.conn": "VERB",
    "status.reconn": "RECONN",
    "status.err": "FEHLER",
    "status.off": "AUS",
    "wallet.xAuthTitle": "X Anmeldung",
    "wallet.xPrompt": "Verbinden Sie X, bevor Sie ein Wallet-Konto generieren.",
    "wallet.xConnectedLabel": "Verbunden als @{handle}",
    "wallet.xHandlePlaceholder": "Geben Sie Ihren X-Namen ein",
    "wallet.connectX": "Mit X verbinden",
    "wallet.disconnectX": "Trennen",
    "wallet.xConnected": "X verbunden — Wallet-Generierung freigeschaltet.",
    "wallet.xLoginRequired": "Verbinden Sie zuerst X, um ein Wallet-Konto zu generieren.",
    "wallet.generateAccount": "Neues Konto generieren",
    "ops.composeTitle": "Einen Callout erstellen",
    "ops.composeHint": "Teilen Sie einen Markt-Callout mit einem On-Chain-Positions-Snapshot.",
    "ops.coinPlaceholder": "Coin oder Mint",
    "ops.messagePlaceholder": "Was callen Sie?",
    "ops.imagePlaceholder": "Bild-URL (optional)",
    "ops.positionType": "Offene Position",
    "ops.positionSnapshot": "Positions-Snapshot",
    "ops.size": "Größe",
    "ops.entry": "Einstieg",
    "ops.notes": "Notizen",
    "ops.walletAddress": "Trading-Wallet-Adresse (optional)",
    "ops.tradeWallet": "Trading-Wallet",
    "ops.copyWallet": "Wallet kopieren",
    "ops.copyWalletNotice": "Wallet-Adresse kopiert",
    "ops.sourceAuto": "Auto",
    "ops.autoReasonLabel": "Quelle",
    "ops.positionValue": "Positionswert: ${value}",
    "ops.post": "Callout posten",
    "ops.copyTrade": "Trade kopieren",
    "ops.copying": "Kopiert",
    "ops.empty": "Noch keine Callouts. Seien Sie der Erste, der einen veröffentlicht.",
    "ops.positionLong": "Long",
    "ops.positionShort": "Short",
    "ops.positionNeutral": "Neutral",
    // Sidebar & Trading
    "trading.mode.paper": "DEMO",
    "trading.mode.real": "REAL",
    "trading.manualSell": "Manueller Verkauf",
    "trading.stopSession": "Sitzung stoppen zum Bearbeiten",
    "trading.live": "live",

    // Order Book
    "orderbook.title": "Orderbuch",
    "orderbook.subtitle": "PumpPortal-Trades für diesen Token",
    "orderbook.total": "Gesamt",
    "orderbook.buys": "Käufe",
    "orderbook.sells": "Verkäufe",
    "orderbook.buyPct": "Kauf %",
    "orderbook.volume": "Volumen",
    "orderbook.buyVol": "Kauf-Vol.",
    "orderbook.sellVol": "Verkauf-Vol.",
    "orderbook.recentPrints": "Neueste Trades ({count})",
    "orderbook.buy": "Kauf",
    "orderbook.sell": "Verkauf",
    "orderbook.waiting": "Warten auf Trades für diesen Token… Bei geringer Liquidität können Trades spärlich sein.",

    // Chart & Analytics
    "chart.suggestLines": "Linien vorschlagen",
    "chart.axis.mc": "Marktkapitalisierung",
    "chart.axis.price": "Preis",
    "chart.timeframe": "Zeitrahmen",
    "chart.timezone": "Zeitzone",
    "chart.loading": "Chartdaten werden geladen...",
    "chart.error": "Fehler beim Laden des Charts",

    // Nursery Panel
    "nursery.tab.yours": "DEINE",
    "nursery.tab.new": "Neu",
    "nursery.tab.grad": "Abschluss",
    "nursery.tab.bonded": "Gebunden",
    "nursery.tab.old": "Alt",
    "nursery.tab.runners": "Läufer",
    "nursery.tab.devs": "Entwickler",
    "nursery.sub.tradable": "Handelbar",
    "nursery.sub.checked": "Geprüft",
    "nursery.sub.blocked": "Blockiert",
    "nursery.sub.unchecked": "Ungeprüft",
    "nursery.sub.stale": "Veraltet",
    "nursery.sort.label": "Sortieren:",
    "nursery.sort.heat": "🔥 Hitze",
    "nursery.sort.coins": "🪙 Coins",
    "nursery.sort.ath": "📈 ATH",
    "nursery.sort.age": "Alter",
    "nursery.sort.mc": "MK",
    "nursery.sort.vol": "Vol/Gebote",
    "nursery.sort.highToLow": "Hoch → Tief",
    "nursery.sort.lowToHigh": "Tief → Hoch",
    "nursery.combinedReturn": "Kombinierte potenzielle Rendite",
    "nursery.smartDeploy": "Smart Deploy",
    "nursery.smartDeployDesc": "Gehen Sie über einfache Starts hinaus. Betten Sie benutzerdefinierte Rust-Hooks ein, schützen Sie Ihre Liquidität mit Anti-Snipe-Logik und schalten Sie exklusive Deployer-Intelligence frei.",
    "nursery.deployNow": "Jetzt bereitstellen",
    "nursery.waitingFeed": "Warten auf Feed...",
    "nursery.noTokensMatch": "Keine Token entsprechen dem aktuellen Filter",
    "nursery.search.placeholder": "400k+ Paare, Dev, Mint durchsuchen...",

    // Signals Panel
    "signals.title": "Signale",
    "signals.filter": "Filter",
    "signals.scanFilter": "Scan-Filter",
    "signals.confidence": "Konfidenz",
    "signals.whaleSol": "Wal SOL",
    "signals.bonding": "Bonding",
    "signals.favSearches": "Favoriten & Suchen",
    "signals.items": "Elemente",
    "signals.monitoring": "Globales Tape wird überwacht\nauf hohe Momentum-Intensität...",
    "signals.age": "Alter",
    "signals.whaleVol": "Wal-Vol.",
    "signals.walletIntel": "Wallet-Intel",
    "signals.standardView": "Standardansicht",
    "signals.lilyView": "Lily Rasteransicht",

    // Search
    "search.recentSearches": "Letzte Suchen",
    "search.priceMC": "Preis / MK",
    "search.liqVol": "Liq / Vol(24h)",
    "search.holders": "Halter",
    "search.priceUsd": "Preis USD",
    "search.liquidity": "Liquidität",
    "search.description": "Beschreibung",
    "search.backToResults": "Zurück zu Ergebnissen",
    "search.copyMint": "Mint kopieren",
    "search.tokenInfo": "Token-Info",

    // Shell panels
    "shell.collapseLeft": "Linkes Panel einklappen",
    "shell.expandLeft": "Linkes Panel ausklappen",
    "shell.collapseSignals": "Signalpanel einklappen",
    "shell.expandSignals": "Signalpanel ausklappen",
    "shell.collapseRight": "Rechtes Panel einklappen",
    "shell.expandRight": "Rechtes Panel ausklappen",
    "shell.agentOps": "Agent-Ops",
    "shell.switchToOps": "Zu Agent-Operationen wechseln",
    "shell.switchToAI": "Zu AI wechseln",

    // Sidebar
    "sidebar.svix": "SVIX",
    "airdrop.title": "Airdrop-Listen",
    "airdrop.extract": "Aktuellen Token extrahieren",
    "airdrop.extracting": "Extrahieren...",
    "airdrop.desc": "Extrahieren Sie Token-Halter von existierenden Token, um Airdrop-Listen zu erstellen. Sie können dann eine Wallet mit einer Airdrop-Liste im Playground über eine \"airdrop\" Kante verknüpfen.",
    "airdrop.empty": "Noch keine Airdrop-Listen vorhanden.",
    "airdrop.remove": "Entfernen",
    "airdrop.recipients": "{count} Empfänger",
    "airdrop.more": "+ {count} weitere",
    "airdrop.retry": "Wiederholen",
    "airdrop.retrying": "Wiederhole...",
    "airdrop.walletsCount": "Wallets",
  },
  fr: {
    // Top Chrome & Shell
    "nav.dashboard": "Tableau de bord",
    "nav.setup": "Configuration",
    "nav.code": "Code",
    "nav.nursery": "Nursery",
    "nav.alpha": "Alpha",
    "nav.wallet": "Portefeuille",
    "nav.proxy": "Proxy",
    "nav.deploy": "Déployer",
    "search.placeholder": "Rechercher des tokens par nom ou adresse...",
    "tooltip.theme": "Changer de thème",
    "tooltip.layout": "Changer la direction de la disposition",
    "tooltip.notifications": "Notifications",
    "tooltip.tps": "Statut du réseau Solana Mainnet-Beta",
    "tooltip.solPrice": "Prix actuel du SOL",
    "tooltip.connectedUsers": "Utilisateurs connectés à la plateforme",
    "tooltip.phantomBalance": "Solde du portefeuille Phantom",
    "tooltip.pumpPortalBalance": "Solde du portefeuille de trading PumpPortal",
    "tooltip.copyAddress": "Copier l'adresse du portefeuille",
    "status.live": "DIRECT",
    "status.conn": "CONNEX",
    "status.reconn": "RECONN",
    "status.err": "ERREUR",
    "status.off": "ARRÊT",
    "wallet.xAuthTitle": "Connexion X",
    "wallet.xPrompt": "Connectez X avant de générer un compte de portefeuille.",
    "wallet.xConnectedLabel": "Connecté en tant que @{handle}",
    "wallet.xHandlePlaceholder": "Entrez votre pseudo X",
    "wallet.connectX": "Connecter X",
    "wallet.disconnectX": "Déconnecter",
    "wallet.xConnected": "X connecté — la génération de portefeuille est débloquée.",
    "wallet.xLoginRequired": "Connectez d'abord X pour générer un compte de portefeuille.",
    "wallet.generateAccount": "Générer un nouveau compte",
    "ops.composeTitle": "Lancer un appel",
    "ops.composeHint": "Partagez un appel de marché avec un aperçu de la position on-chain.",
    "ops.coinPlaceholder": "Coin ou adresse",
    "ops.messagePlaceholder": "Qu'appelez-vous ?",
    "ops.imagePlaceholder": "URL de l'image (facultatif)",
    "ops.positionType": "Position ouverte",
    "ops.positionSnapshot": "Aperçu de la position",
    "ops.size": "Taille",
    "ops.entry": "Entrée",
    "ops.notes": "Notes",
    "ops.walletAddress": "Adresse du portefeuille de trading (facultatif)",
    "ops.tradeWallet": "Portefeuille de trading",
    "ops.copyWallet": "Copier le portefeuille",
    "ops.copyWalletNotice": "Adresse du portefeuille copiée",
    "ops.sourceAuto": "Auto",
    "ops.autoReasonLabel": "Source",
    "ops.positionValue": "Valeur de la position : ${value}",
    "ops.post": "Publier l'appel",
    "ops.copyTrade": "Copier le trade",
    "ops.copying": "Copié",
    "ops.empty": "Aucun appel pour le moment. Soyez le premier à en publier un.",
    "ops.positionLong": "Long",
    "ops.positionShort": "Court",
    "ops.positionNeutral": "Neutre",
    // Sidebar & Trading
    "trading.mode.paper": "DÉMO",
    "trading.mode.real": "RÉEL",
    "trading.manualSell": "Vente Manuelle",
    "trading.stopSession": "arrêter la session pour modifier",
    "trading.live": "en direct",

    // Order Book
    "orderbook.title": "Carnet d'ordres",
    "orderbook.subtitle": "Transactions PumpPortal pour ce token",
    "orderbook.total": "Total",
    "orderbook.buys": "Achats",
    "orderbook.sells": "Ventes",
    "orderbook.buyPct": "% Achat",
    "orderbook.volume": "Volume",
    "orderbook.buyVol": "Vol. Achat",
    "orderbook.sellVol": "Vol. Vente",
    "orderbook.recentPrints": "Transactions récentes ({count})",
    "orderbook.buy": "Achat",
    "orderbook.sell": "Vente",
    "orderbook.waiting": "En attente de transactions pour ce token... Si le token est peu liquide, les transactions peuvent être rares.",

    // Chart & Analytics
    "chart.suggestLines": "Suggérer des lignes",
    "chart.axis.mc": "Cap. boursière",
    "chart.axis.price": "Prix",
    "chart.timeframe": "Période",
    "chart.timezone": "Fuseau horaire",
    "chart.loading": "Chargement des données du graphique...",
    "chart.error": "Erreur de chargement du graphique",

    // Nursery Panel
    "nursery.tab.yours": "VÔTRES",
    "nursery.tab.new": "Nouveau",
    "nursery.tab.grad": "Diplômé",
    "nursery.tab.bonded": "Lié",
    "nursery.tab.old": "Ancien",
    "nursery.tab.runners": "Coureurs",
    "nursery.tab.devs": "Développeurs",
    "nursery.sub.tradable": "Négociable",
    "nursery.sub.checked": "Vérifié",
    "nursery.sub.blocked": "Bloqué",
    "nursery.sub.unchecked": "Non vérifié",
    "nursery.sub.stale": "Périmé",
    "nursery.sort.label": "Trier par :",
    "nursery.sort.heat": "🔥 Chaleur",
    "nursery.sort.coins": "🪙 Coins",
    "nursery.sort.ath": "📈 ATH",
    "nursery.sort.age": "Âge",
    "nursery.sort.mc": "Cap.",
    "nursery.sort.vol": "Vol/Offres",
    "nursery.sort.highToLow": "Haut → Bas",
    "nursery.sort.lowToHigh": "Bas → Haut",
    "nursery.combinedReturn": "Rendement potentiel combiné",
    "nursery.smartDeploy": "Déploiement intelligent",
    "nursery.smartDeployDesc": "Allez au-delà des lancements basiques. Intégrez des hooks Rust personnalisés, protégez votre liquidité avec la logique Anti-Snipe et débloquez l'intelligence exclusive du Deployer.",
    "nursery.deployNow": "Déployer maintenant",
    "nursery.waitingFeed": "En attente du flux...",
    "nursery.noTokensMatch": "Aucun token ne correspond au filtre actuel",
    "nursery.search.placeholder": "Rechercher 400k+ paires, dev, mint...",

    // Signals Panel
    "signals.title": "Signaux",
    "signals.filter": "Filtre",
    "signals.scanFilter": "Filtre de scan",
    "signals.confidence": "Confiance",
    "signals.whaleSol": "Baleine SOL",
    "signals.bonding": "Liaison",
    "signals.favSearches": "Favoris et recherches",
    "signals.items": "éléments",
    "signals.monitoring": "Surveillance du flux global pour\nun momentum de haute intensité...",
    "signals.age": "Âge",
    "signals.whaleVol": "Vol. baleine",
    "signals.walletIntel": "Intel portefeuille",
    "signals.standardView": "Vue standard",
    "signals.lilyView": "Vue grille Lily",

    // Search
    "search.recentSearches": "Recherches récentes",
    "search.priceMC": "Prix / Cap.",
    "search.liqVol": "Liq / Vol(24h)",
    "search.holders": "Détenteurs",
    "search.priceUsd": "Prix USD",
    "search.liquidity": "Liquidité",
    "search.description": "Description",
    "search.backToResults": "Retour aux résultats",
    "search.copyMint": "Copier Mint",
    "search.tokenInfo": "Info du token",

    // Shell panels
    "shell.collapseLeft": "Réduire le panneau gauche",
    "shell.expandLeft": "Développer le panneau gauche",
    "shell.collapseSignals": "Réduire le panneau signaux",
    "shell.expandSignals": "Développer le panneau signaux",
    "shell.collapseRight": "Réduire le panneau droit",
    "shell.expandRight": "Développer le panneau droit",
    "shell.agentOps": "Ops agent",
    "shell.switchToOps": "Passer aux opérations agent",
    "shell.switchToAI": "Passer à l'IA",

    // Sidebar
    "sidebar.svix": "SVIX",
    "airdrop.title": "Listes d'airdrop",
    "airdrop.extract": "Extraire le jeton actuel",
    "airdrop.extracting": "Extraction...",
    "airdrop.desc": "Extrayez les détenteurs de jetons existants pour créer des listes d'airdrop. Vous pouvez ensuite lier un portefeuille à une liste d'airdrop dans le Playground en utilisant une arête \"airdrop\".",
    "airdrop.empty": "Aucune liste d'airdrop pour le moment.",
    "airdrop.remove": "Supprimer",
    "airdrop.recipients": "{count} destinataires",
    "airdrop.more": "+ {count} de plus",
    "airdrop.retry": "Réessayer",
    "airdrop.retrying": "Réessai...",
    "airdrop.walletsCount": "Portefeuilles",
  },
  pt: {
    // Top Chrome & Shell
    "nav.dashboard": "Painel",
    "nav.setup": "Configuração",
    "nav.code": "Código",
    "nav.nursery": "Nursery",
    "nav.alpha": "Alpha",
    "nav.wallet": "Carteira",
    "nav.proxy": "Proxy",
    "nav.deploy": "Implantar",
    "search.placeholder": "Buscar tokens por nome ou endereço...",
    "tooltip.theme": "Alternar tema",
    "tooltip.layout": "Alternar direção do layout",
    "tooltip.notifications": "Notificações",
    "tooltip.tps": "Status da rede principal do Solana",
    "tooltip.solPrice": "Preço atual do SOL",
    "tooltip.connectedUsers": "Usuários conectados à plataforma",
    "tooltip.phantomBalance": "Saldo da carteira Phantom",
    "tooltip.pumpPortalBalance": "Saldo da carteira de trading PumpPortal",
    "tooltip.copyAddress": "Copiar endereço da carteira",
    "status.live": "ATIVO",
    "status.conn": "CONECT",
    "status.reconn": "RECONECT",
    "status.err": "ERRO",
    "status.off": "DESLIG",
    "wallet.xAuthTitle": "Login no X",
    "wallet.xPrompt": "Conecte o X antes de gerar uma carteira.",
    "wallet.xConnectedLabel": "Conectado como @{handle}",
    "wallet.xHandlePlaceholder": "Digite seu @ do X",
    "wallet.connectX": "Conectar X",
    "wallet.disconnectX": "Desconectar",
    "wallet.xConnected": "X conectado — a geração de carteira está desbloqueada.",
    "wallet.xLoginRequired": "Conecte o X primeiro para gerar uma carteira.",
    "wallet.generateAccount": "Gerar Nova Conta",
    "ops.composeTitle": "Lançar um callout",
    "ops.composeHint": "Compartilhe uma chamada com um snapshot de posição on-chain.",
    "ops.coinPlaceholder": "Moeda ou contrato",
    "ops.messagePlaceholder": "O que você está chamando?",
    "ops.imagePlaceholder": "URL da imagem (opcional)",
    "ops.positionType": "Posição aberta",
    "ops.positionSnapshot": "Snapshot da posição",
    "ops.size": "Tamanho",
    "ops.entry": "Entrada",
    "ops.notes": "Notas",
    "ops.walletAddress": "Endereço da carteira de trading (opcional)",
    "ops.tradeWallet": "Carteira de trading",
    "ops.copyWallet": "Copiar carteira",
    "ops.copyWalletNotice": "Endereço da carteira copiado",
    "ops.sourceAuto": "Auto",
    "ops.autoReasonLabel": "Fonte",
    "ops.positionValue": "Valor da posição: ${value}",
    "ops.post": "Postar callout",
    "ops.copyTrade": "Copiar trade",
    "ops.copying": "Copiado",
    "ops.empty": "Ainda não há callouts. Seja o primeiro a publicar um.",
    "ops.positionLong": "Long",
    "ops.positionShort": "Short",
    "ops.positionNeutral": "Neutro",
    // Sidebar & Trading
    "trading.mode.paper": "DEMO",
    "trading.mode.real": "REAL",
    "trading.manualSell": "Venda Manual",
    "trading.stopSession": "pare a sessão para editar",
    "trading.live": "ao vivo",

    // Order Book
    "orderbook.title": "Livro de ofertas",
    "orderbook.subtitle": "Negociações PumpPortal para este token",
    "orderbook.total": "Total",
    "orderbook.buys": "Compras",
    "orderbook.sells": "Vendas",
    "orderbook.buyPct": "% Compra",
    "orderbook.volume": "Volume",
    "orderbook.buyVol": "Vol. Compra",
    "orderbook.sellVol": "Vol. Venda",
    "orderbook.recentPrints": "Negociações recentes ({count})",
    "orderbook.buy": "Compra",
    "orderbook.sell": "Venda",
    "orderbook.waiting": "Aguardando negociações deste token... Se o token for ilíquido, as negociações podem ser escassas.",

    // Chart & Analytics
    "chart.suggestLines": "Sugerir linhas",
    "chart.axis.mc": "Cap. de mercado",
    "chart.axis.price": "Preço",
    "chart.timeframe": "Tempo",
    "chart.timezone": "Fuso horário",
    "chart.loading": "Carregando dados do gráfico...",
    "chart.error": "Erro ao carregar o gráfico",

    // Nursery Panel
    "nursery.tab.yours": "SEUS",
    "nursery.tab.new": "Novo",
    "nursery.tab.grad": "Graduado",
    "nursery.tab.bonded": "Vinculado",
    "nursery.tab.old": "Antigo",
    "nursery.tab.runners": "Corredores",
    "nursery.tab.devs": "Desenvolvedores",
    "nursery.sub.tradable": "Negociável",
    "nursery.sub.checked": "Verificado",
    "nursery.sub.blocked": "Bloqueado",
    "nursery.sub.unchecked": "Não verificado",
    "nursery.sub.stale": "Obsoleto",
    "nursery.sort.label": "Ordenar por:",
    "nursery.sort.heat": "🔥 Calor",
    "nursery.sort.coins": "🪙 Coins",
    "nursery.sort.ath": "📈 ATH",
    "nursery.sort.age": "Idade",
    "nursery.sort.mc": "Cap.",
    "nursery.sort.vol": "Vol/Ofertas",
    "nursery.sort.highToLow": "Alto → Baixo",
    "nursery.sort.lowToHigh": "Baixo → Alto",
    "nursery.combinedReturn": "Retorno potencial combinado",
    "nursery.smartDeploy": "Deploy inteligente",
    "nursery.smartDeployDesc": "Vá além dos lançamentos básicos. Integre hooks Rust personalizados, proteja sua liquidez com lógica Anti-Snipe e desbloqueie inteligência exclusiva do Deployer.",
    "nursery.deployNow": "Implantar agora",
    "nursery.waitingFeed": "Aguardando feed...",
    "nursery.noTokensMatch": "Nenhum token corresponde ao filtro atual",
    "nursery.search.placeholder": "Buscar 400k+ pares, dev, mint...",

    // Signals Panel
    "signals.title": "Sinais",
    "signals.filter": "Filtro",
    "signals.scanFilter": "Filtro de varredura",
    "signals.confidence": "Confiança",
    "signals.whaleSol": "Baleia SOL",
    "signals.bonding": "Vinculação",
    "signals.favSearches": "Favoritos e buscas",
    "signals.items": "itens",
    "signals.monitoring": "Monitorando fita global em busca de\nmomentum de alta intensidade...",
    "signals.age": "Idade",
    "signals.whaleVol": "Vol. baleia",
    "signals.walletIntel": "Intel de carteira",
    "signals.standardView": "Vista padrão",
    "signals.lilyView": "Vista de grade Lily",

    // Search
    "search.recentSearches": "Buscas recentes",
    "search.priceMC": "Preço / Cap.",
    "search.liqVol": "Liq / Vol(24h)",
    "search.holders": "Detentores",
    "search.priceUsd": "Preço USD",
    "search.liquidity": "Liquidez",
    "search.description": "Descrição",
    "search.backToResults": "Voltar aos resultados",
    "search.copyMint": "Copiar Mint",
    "search.tokenInfo": "Info do token",

    // Shell panels
    "shell.collapseLeft": "Recolher painel esquerdo",
    "shell.expandLeft": "Expandir painel esquerdo",
    "shell.collapseSignals": "Recolher painel de sinais",
    "shell.expandSignals": "Expandir painel de sinais",
    "shell.collapseRight": "Recolher painel direito",
    "shell.expandRight": "Expandir painel direito",
    "shell.agentOps": "Ops de agente",
    "shell.switchToOps": "Mudar para operações de agente",
    "shell.switchToAI": "Mudar para IA",

    // Sidebar
    "sidebar.svix": "SVIX",
    "airdrop.title": "Listas de Airdrop",
    "airdrop.extract": "Extrair Token Atual",
    "airdrop.extracting": "Extraindo...",
    "airdrop.desc": "Extraia detentores de tokens de tokens existentes para criar listas de airdrop. Você pode então vincular uma carteira a uma lista de airdrop no Playground usando uma aresta \"airdrop\".",
    "airdrop.empty": "Nenhuma lista de airdrop ainda.",
    "airdrop.remove": "Remover",
    "airdrop.recipients": "{count} destinatários",
    "airdrop.more": "+ {count} mais",
    "airdrop.retry": "Repetir",
    "airdrop.retrying": "Repetindo...",
    "airdrop.walletsCount": "Carteiras",
  },
} as const;

export type TranslationKey = keyof typeof TRANSLATIONS.en;
